import { smsTemplateSchema } from "@redotech/redo-model/sms-template";
import * as z from "zod";

const createSmsTemplateInputSchema_ = z.object({
  template: smsTemplateSchema.omit({ _id: true }),
});

export interface CreateSmsTemplateInput
  extends z.infer<typeof createSmsTemplateInputSchema_> {}

export const createSmsTemplateInputSchema: z.ZodType<CreateSmsTemplateInput> =
  createSmsTemplateInputSchema_;

export const createSmsTemplate = {
  name: "createSmsTemplate" as const,
  input: createSmsTemplateInputSchema,
  output: smsTemplateSchema,
};
